import { push } from 'redux-first-history';
import * as types from './types';

export { createAsyncActionType } from './async';

export const actionPushUrl = (url) => push(url);

export const actionModalOpen = (id, props) => ({
  type: types.MODAL_OPEN,
  payload: { id, props },
});

export const actionModalClose = () => ({
  type: types.MODAL_CLOSE,
});

export const actionTooltipOpen = (id) => ({
  type: types.TOOLTIP_OPEN,
  payload: { id },
});

export const actionTooltipClose = () => ({
  type: types.TOOLTIP_CLOSE,
});

export const actionSpinnerOpen = () => ({
  type: types.SPINNER_OPEN,
});

export const actionSpinnerClose = () => ({
  type: types.SPINNER_CLOSE,
});

export const actionLocalizationLoaded = ({ app, common }) => ({
  type: types.LOCALIZATION_LOADED,
  payload: { app, common },
});

export const actionLocalizationSelect = (lang) => ({
  type: types.LOCALIZATION_SELECT,
  payload: { lang },
});

export const actionFeeStructuresGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'feeStructures' },
});

export const actionUserTitlesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'userTitles' },
});

export const actionCountriesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'countries' },
});

export const actionDocumentTypesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'documentTypes' },
});

export const actionAccountTypesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'accountTypes' },
});

export const actionInvestmentObjectiveTypesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'investmentObjectiveTypes' },
});

export const actionRiskAppetiteProfilesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'riskAppetiteProfiles' },
});

export const actionRandomWeightsGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'randomWeights' },
});

export const actionRiskProfilesTypesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'riskProfiles' },
});

export const actionMandateTypesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'mandateTypes' },
});

export const actionInstrumentsIndexGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'instrumentsIndex' },
});

export const actionCrmOwnersGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'crmOwners' },
});

export const actionMaxDrawdownScenariosGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'maxDrawdownScenarios' },
});

export const actionAmlProfilesPropertiesGet = () => ({
  type: types.STATIC_VALUES_GET._REQUEST,
  payload: { valueName: 'amlProfilesProperties' },
});

export const actionLayoutErrorSet = (error) => ({
  type: types.LAYOUT_SET_ERROR,
  payload: { error },
});

export const actionBadRequestErrorSet = (error, request) => ({
  type: types.SET_BAD_REQUEST_ERROR,
  payload: { request, error },
});

export const actionBadRequestErrorClear = (request) => ({
  type: types.CLEAR_BAD_REQUEST_ERROR,
  payload: { request },
});

export const actionGlobalComponentsSet = (name, type, props) => ({
  type: types.SET_GLOBAL_COMPONENTS,
  payload: { name, type, props },
});

export const actionGlobalComponentsClear = (name) => ({
  type: types.CLEAR_GLOBAL_COMPONENTS,
  payload: { name },
});

export const actionUserNotificationsGet = (userId) => ({
  type: types.USER_NOTIFICATIONS_GET._REQUEST,
  payload: { userId },
});

export const actionUserNotificationsRead = (userId) => ({
  type: types.USER_NOTIFICATIONS_READ._REQUEST,
  payload: { userId },
});

export const actionNotificationDelete = ({ notificationId, userId }) => ({
  type: types.NOTIFICATION_DELETE._REQUEST,
  payload: { notificationId, userId },
});

export const actionUserAddressesGet = (userId) => ({
  type: types.USER_ADDRESSES_GET._REQUEST,
  payload: { userId },
});

export const actionUserAddressDelete = ({ userId, addressId }) => ({
  type: types.USER_ADDRESSES_DELETE._REQUEST,
  payload: { userId, addressId },
});

export const actionUserAddressPatch = (payload) => ({
  type: types.USER_ADDRESSES_PATCH._REQUEST,
  payload,
});

export const actionUserAddressPost = (payload) => ({
  type: types.USER_ADDRESSES_POST._REQUEST,
  payload,
});

export const actionUserDocumentsGet = (userId) => ({
  type: types.USER_DOCUMENTS_GET._REQUEST,
  payload: { userId },
});

export const actionUserDocumentPatch = (payload) => ({
  type: types.USER_DOCUMENTS_PATCH._REQUEST,
  payload,
});

export const actionUserProfileImageGet = (payload) => ({
  type: types.USER_PROFILE_IMAGE_GET._REQUEST,
  payload,
});

export const actionUserProfileImagePost = (payload) => ({
  type: types.USER_PROFILE_IMAGE_POST._REQUEST,
  payload,
});

export const actionUserProfileImageDelete = (payload) => ({
  type: types.USER_PROFILE_IMAGE_DELETE._REQUEST,
  payload,
});

export const actionUsersGet = () => ({
  type: types.USERS_GET._REQUEST,
});

export const actionUsersPost = (payload) => ({
  type: types.USERS_POST._REQUEST,
  payload,
});

export const actionUserGet = (userId, options) => ({
  type: types.USER_GET._REQUEST,
  payload: { userId, ...options },
});

export const actionUserPatch = (user) => ({
  type: types.USER_PATCH._REQUEST,
  payload: user,
});

export const actionUserDetailsPatch = (user) => ({
  type: types.USER_DETAILS_PATCH._REQUEST,
  payload: user,
});

export const actionUserMainContactsPatch = (payload) => ({
  type: types.USER_MAIN_CONTACTS_PATCH._REQUEST,
  payload,
});

export const actionUserMainContactsPatchOtp = (payload) => ({
  type: types.USER_MAIN_CONTACTS_PATCH_OTP._REQUEST,
  payload,
});

export const actionUserPatchRequest = (user) => ({
  type: types.PROFILE_INFO_SAVE._REQUEST,
  payload: user,
});

export const actionPortfolioProposalsPatch = ({
  accountId,
  investmentObjectiveId,
  proposalId,
  url,
  ...proposal
}) => ({
  type: types.PORTFOLIO_PROPOSALS_PATCH._REQUEST,
  payload: { accountId, investmentObjectiveId, proposalId, url, proposal },
});

export const actionPortfolioProposalsPublish = ({
  investmentObjectiveId,
  proposalId,
  published,
  onSuccess
}) => ({
  type: types.PORTFOLIO_PROPOSALS_PUBLISH._REQUEST,
  payload: { investmentObjectiveId, proposalId, published, onSuccess },
});

export const actionMultiplePortfolioProposalPublish = ({
  investmentObjectiveId,
  portfolioProposals,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_MULTIPLE_PUBLISH._REQUEST,
  payload: { investmentObjectiveId, portfolioProposals },
});

export const actionProfileAddressSaveRequest = ({
  addressType,
  streetName,
  city,
  province,
  postCode,
  countryId,
  id,
  backUrl,
}) => ({
  type: types.PROFILE_ADDRESS_SAVE._REQUEST,
  payload: { addressType, streetName, city, province, postCode, countryId, id, backUrl },
});

export const actionProfileDocSaveRequest = (payload) => ({
  type: types.PROFILE_DOC_SAVE._REQUEST,
  payload,
});

export const actionProfileAddressGetRequest = () => ({
  type: types.PROFILE_ADDRESSES_GET._REQUEST,
});

export const actionAddressGet = (userId) => ({
  type: types.ADDRESSES_GET._REQUEST,
  payload: { userId },
});

export const actionDocumentsGet = (userId) => ({
  type: types.DOCUMENTS_GET._REQUEST,
  payload: { userId },
});

export const actionDocumentFilesGet = (document) => ({
  type: types.DOCUMENT_FILES_GET._REQUEST,
  payload: { document },
});

export const actionDocumentFileGet = ({ documentId, fileId }) => ({
  type: types.DOCUMENT_FILE_GET._REQUEST,
  payload: { documentId, fileId },
});

export const actionUserDocumentPost = (payload) => ({
  type: types.USER_DOCUMENTS_POST._REQUEST,
  payload,
});

export const actionProfileAddressDeleteRequest = (id) => ({
  type: types.PROFILE_ADDRESS_DELETE._REQUEST,
  payload: { id },
});

export const actionProfileDocsGetRequest = () => ({
  type: types.PROFILE_DOCUMENTS_GET._REQUEST,
});

export const actionProfileDocDeleteRequest = (id) => ({
  type: types.PROFILE_DOC_DELETE._REQUEST,
  payload: { id },
});

export const actionProfileDocFilesGetRequest = ({ doc }) => ({
  type: types.PROFILE_DOC_FILES_GET._REQUEST,
  payload: { doc },
});

export const actionProfilePinSave = ({ pin, backUrl }) => ({
  type: types.PROFILE_PIN_SAVE._REQUEST,
  payload: { pin, backUrl },
});

export const actionWizardClean = () => ({
  type: types.WIZARD_CLEAN_DATA,
});

export const actionWizardUpdate = (payload) => ({
  type: types.WIZARD_UPDATE_DATA,
  payload,
});

export const actionTotalWealthProfileSimRequest = (payload) => ({
  type: types.TOTAL_WEALTH_PROFILE_SIMULATION._REQUEST,
  payload,
});

export const actionAccountsSetFilter = (search) => ({
  type: types.ACCOUNTS_SET_FILTER,
  payload: search,
});

export const actionAccountsGet = (userId) => ({
  type: types.ACCOUNTS_GET._REQUEST,
  payload: { userId },
});

export const actionAccountGet = (accountId) => ({
  type: types.ACCOUNT_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountCreate = ({
  accountType,
  name,
  lastname,
  financialAdvisorId,
  ownerId,
  url,
}) => ({
  type: types.ACCOUNTS_POST._REQUEST,
  payload: { accountType, name, lastname, financialAdvisorId, ownerId, url },
});

export const actionPortfolioProposalsHoldingsGet = (proposalId) => ({
  type: types.PORTFOLIO_PROPOSALS_HOLDINGS_GET._REQUEST,
  payload: { proposalId },
});

export const actionPortfolioProposalsDetailsGet = (proposalId) => ({
  type: types.PORTFOLIO_PROPOSALS_DETAILS_GET._REQUEST,
  payload: { proposalId },
});

export const actionPortfolioProposalsKpisGet = ({
  proposalId,
  proposalIds,
  startDate,
  endDate,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_KPIS_GET._REQUEST,
  payload: { proposalId, proposalIds, startDate, endDate },
});

export const actionPortfolioProposalsHoldingsPatch = ({
  investmentObjectiveId,
  proposalId,
  holdings,
  options,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_HOLDINGS_PATCH._REQUEST,
  payload: { investmentObjectiveId, proposalId, holdings, options },
});

export const actionPortfolioProposalsMaxDrawdownGet = (
  { proposalId, startDate, endDate, benchmarkId, samplingInterval },
  options
) => ({
  type: types.PORTFOLIO_PROPOSALS_MAX_DRAWDOWN_GET._REQUEST,
  payload: { proposalId, startDate, endDate, benchmarkId, samplingInterval, options },
});

export const actionSimulationHoldingsOptimizationWithKpis = ({ id, ...payload }) => ({
  type: types.SIMULATIONS_HOLDINGS_OPTIMIZATION._REQUEST,
  payload: {
    objectId: id,
    calculateKpis: true,
    ...payload,
  },
});

export const actionSimulationHoldingsOptimization = ({ id, ...payload }) => ({
  type: types.SIMULATIONS_HOLDINGS_OPTIMIZATION._REQUEST,
  payload: {
    objectId: id,
    calculateKpis: false,
    ...payload,
  },
});

export const actionSimulationHoldingsKpis = (items) => ({
  type: types.SIMULATIONS_HOLDINGS_KPIS._REQUEST,
  payload: { items },
});

export const actionSimulationHoldingsOptimizationClear = ({ id, type }) => ({
  type: types.SIMULATIONS_HOLDINGS_OPTIMIZATION_CLEAR,
  payload: { objectId: id, type },
});

export const actionSimulationInvestmentForecastGet = ({ id, ...payload }) => ({
  type: types.SIMULATIONS_INVESTMENT_FORECAST._REQUEST,
  payload: {
    objectId: id,
    ...payload,
  },
});

export const actionSimulationInvestmentRecommendationsGet = ({ id, ...payload }) => ({
  type: types.SIMULATIONS_INVESTMENT_RECOMMENDATION._REQUEST,
  payload: {
    objectId: id,
    ...payload,
  },
});

export const actionSimulationExpectedFees = ({ id, ...payload }) => ({
  type: types.SIMULATIONS_EXPECTED_FEES._REQUEST,
  payload: {
    objectId: id,
    ...payload,
  },
});

export const actionPortfolioProposalsHoldingsOptimize = ({
  proposalId,
  targetVar,
  constraints,
  holdings,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_HOLDINGS_OPTIMIZATION._REQUEST,
  payload: { proposalId, targetVar, constraints, holdings },
});

export const actionPortfoliosHoldingsGet = (portfolioId) => ({
  type: types.PORTFOLIOS_HOLDINGS_GET._REQUEST,
  payload: { portfolioId },
});

export const actionPortfoliosDetailsGet = (portfolioId) => ({
  type: types.PORTFOLIOS_DETAILS_GET._REQUEST,
  payload: { portfolioId },
});

export const actionAccountProfilesStepsGet = (accountId) => ({
  type: types.ACCOUNT_PROFILE_STEPS_GET._REQUEST,
  payload: { accountId },
});

export const actionRiskProfilesSimulationRequest = (payload) => ({
  type: types.RISK_PROFILES_SIMULATION._REQUEST,
  payload,
});

export const actionAccountProfileStep3Set = (payload) => ({
  type: types.ACCOUNT_PROFILE_STEP_3_SET._REQUEST,
  payload,
});

export const actionPortfolioProposalsCopy = ({
  accountId,
  investmentObjectiveId,
  name,
  parentProposalId,
  onbData,
  onSuccess,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_COPY._REQUEST,
  payload: { accountId, investmentObjectiveId, name, parentProposalId, onbData, onSuccess },
});

export const actionPortfolioProposalsCopyFromModel = ({
  accountId,
  investmentObjectiveId,
  name,
  modelPortfolioId,
}) => ({
  type: types.PORTFOLIO_PROPOSALS_COPY._REQUEST,
  payload: { accountId, investmentObjectiveId, name, parentModelPortfolioId: modelPortfolioId },
});

export const actionAccountMifidProfilesPost = (accountId) => ({
  type: types.ACCOUNT_MIFID_PROFILE_POST._REQUEST,
  payload: { accountId },
});

export const actionAccountRiskProfilePost = ({ accountId, riskProfile }) => ({
  type: types.ACCOUNT_RISK_PROFILE_POST._REQUEST,
  payload: { accountId, riskProfile },
});

export const actionAccountInvestmentAgreementsGet = () => ({
  type: types.ACCOUNT_INVESTMENT_AGREEMENTS_GET._REQUEST,
});

export const actionAccountSignedInvestmentAgreementsGet = (accountId) => ({
  type: types.ACCOUNT_SIGNED_INVESTMENT_AGREEMENTS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountInvestmentAgreementsPost = (accountId, { contractId, otp }) => ({
  type: types.ACCOUNT_INVESTMENT_AGREEMENTS_POST._REQUEST,
  payload: { accountId, contractId, otp, options: { handleBadRequest: true } },
});

export const actionAccountInvestmentAgreementsPostOtp = (accountId, { contractId, otp }) => ({
  type: types.ACCOUNT_INVESTMENT_AGREEMENTS_POST_OTP._REQUEST,
  payload: { accountId, contractId, otp, options: { handleBadRequest: true } },
});

export const actionAccountAcceptMifidProfile = (payload) => ({
  type: types.ACCOUNT_ACCEPT_MIFID_PROFILE._REQUEST,
  payload,
});

export const actionAccountConfirmInfo = (payload) => ({
  type: types.ACCOUNT_CONFIRM_INFO._REQUEST,
  payload,
});

export const actionAccountContractsGet = (accountId) => ({
  type: types.ACCOUNT_CONTRACTS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountContractsPollingGet = (accountId) => ({
  type: types.ACCOUNT_CONTRACTS_POLLING_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountContractsSignPostOtp = ({ accountId, ids, url, otp, alias }) => ({
  type: types.ACCOUNT_CONTRACTS_SIGN_POST_OTP._REQUEST,
  payload: { accountId, ids, url, otp, alias, options: { handleBadRequest: true } },
});

export const actionAccountAmlProfilesGet = (accountId) => ({
  type: types.ACCOUNT_AML_PROFILES_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountAmlProfilesPostPatch = (payload) => ({
  type: types.ACCOUNT_AML_PROFILES_POST_PATCH._REQUEST,
  payload,
});

export const actionAccountTaxSchemesGet = (accountId) => ({
  type: types.ACCOUNT_TAX_SCHEMES_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountTaxSchemesPostPatch = (payload) => ({
  type: types.ACCOUNT_TAX_SCHEMES_POST_PATCH._REQUEST,
  payload,
});

export const actionAccountSimulateRiskProfile = (accountId) => ({
  type: types.ACCOUNT_SIMULATE_RISK_PROFILE._REQUEST,
  payload: { accountId },
});

export const actionAccountFinancialExperiencesSet = (payload) => ({
  type: types.ACCOUNT_FINANCIAL_EXPERIENCES_SET._REQUEST,
  payload,
});

export const actionAccountRiskAppetiteProfilesSetRequest = (payload) => ({
  type: types.ACCOUNT_RISK_APPETITE_PROFILES_SET._REQUEST,
  payload,
});

export const actionInvestmentObjectivePortfolioProposalsGet = (investmentObjectiveIds) => ({
  type: types.INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_GET._REQUEST,
  payload: { investmentObjectiveIds },
});

export const actionInvestmentObjectivePortfolioProposalsPost = (payload) => ({
  type: types.INVESTMENT_OBJECTIVE_PORTFOLIO_PROPOSALS_POST._REQUEST,
  payload,
});

export const actionInvestmentObjectivePortfoliosGetRequest = (investmentObjectiveIds) => ({
  type: types.INVESTMENT_OBJECTIVE_PORTFOLIOS_GET._REQUEST,
  payload: { investmentObjectiveIds },
});

export const actionPortfolioProposalsBenchmarkGet = (payload) => ({
  type: types.PORTFOLIO_PROPOSALS_BENCHMARK_GET._REQUEST,
  payload,
});

export const actionPortfoliosBenchmarkGet = (payload) => ({
  type: types.PORTFOLIOS_BENCHMARK_GET._REQUEST,
  payload,
});

export const actionPortfoliosKpisGet = (payload) => ({
  type: types.PORTFOLIOS_KPIS_GET._REQUEST,
  payload,
});

export const actionAccountSignContractRequest = ({ account, contract, pin }) => ({
  type: types.ACCOUNT_SIGN_CONTRACT_POST._REQUEST,
  payload: { account, contract, pin },
});

export const actionClientDashboardRequest = (accountId) => ({
  type: types.CLIENT_DASHBOARD_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountInvestmentObjectivesGet = (accountId) => ({
  type: types.ACCOUNT_INVESTMENT_OBJECTIVES_GET._REQUEST,
  payload: { accountId },
});

export const actionInvestmentObjectiveGet = ({
  investmentObjectiveId,
  investmentObjectiveIds,
}) => ({
  type: types.INVESTMENT_OBJECTIVE_GET._REQUEST,
  payload: { investmentObjectiveId, investmentObjectiveIds },
});

export const actionAccountInvestmentObjectivesPostPatch = ({
  accountId,
  investmentObjectiveId,
  url,
  onFinish,
  ...investmentObjective
}) => ({
  type: types.ACCOUNT_INVESTMENT_OBJECTIVES_POST_PATCH._REQUEST,
  payload: { accountId, investmentObjectiveId, investmentObjective, url, onFinish },
});

export const actionAccountLifestyleCostsGet = (accountId) => ({
  type: types.ACCOUNT_LIFESTYLE_COSTS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountLifestyleCostsPostPatch = ({
  accountId,
  lifestyleCostsId,
  url,
  ...lifestyleCosts
}) => ({
  type: types.ACCOUNT_LIFESTYLE_COSTS_POST_PATCH._REQUEST,
  payload: { accountId, lifestyleCostsId, lifestyleCosts, url },
});

export const actionAccountFinancialAssetsGet = (accountId) => ({
  type: types.ACCOUNT_FINANCIAL_ASSETS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountFinancialAssetsPostPatch = ({
  accountId,
  financialAssetsId,
  url,
  ...financialAssets
}) => ({
  type: types.ACCOUNT_FINANCIAL_ASSETS_POST_PATCH._REQUEST,
  payload: { accountId, financialAssetsId, financialAssets, url },
});

export const actionAccountFinancialExperiencesGet = (accountId) => ({
  type: types.ACCOUNT_FINANCIAL_EXPERIENCES_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountFinancialExperiencesPostPatch = ({
  accountId,
  financialExperiencesId,
  url,
  ...financialExperiences
}) => ({
  type: types.ACCOUNT_FINANCIAL_EXPERIENCES_POST_PATCH._REQUEST,
  payload: { accountId, financialExperiencesId, financialExperiences, url },
});

export const actionAccountRiskAppetiteProfilesGet = (accountId) => ({
  type: types.ACCOUNT_RISK_APPETITE_PROFILES_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountRiskAppetiteProfilesPostPatch = (payload) => ({
  type: types.ACCOUNT_RISK_APPETITE_PROFILES_POST_PATCH._REQUEST,
  payload,
});

/* Investment Objectives */

export const actionInvestmentObjectivesPatch = (
  id,
  { accountId, url, ...investmentObjective }
) => ({
  type: types.INVESTMENT_OBJECTIVES_PATCH._REQUEST,
  payload: { id, investmentObjective, accountId, url },
});

export const actionInvestmentObjectivesChangeRequest = (id, { desiredVar, message }) => ({
  type: types.INVESTMENT_OBJECTIVES_CHANGE_REQUEST._REQUEST,
  payload: { id, desiredVar, message },
});

/* Wallets */

export const actionPortfolioWalletsGet = (portfolioId) => ({
  type: types.PORTFOLIO_WALLETS_GET._REQUEST,
  payload: { portfolioId },
});

export const actionWalletTransactionsGet = ({ portfolioId, walletId }) => ({
  type: types.WALLETS_TRANSACTIONS_GET._REQUEST,
  payload: { portfolioId, walletId },
});

export const actionWalletWithTransactionsGet = (portfolioId) => ({
  type: types.WALLETS_WITH_TRANSACTIONS_GET._REQUEST,
  payload: { portfolioId },
});

// Deposit - Withdraw - PortfolioDeposit - PortfolioWithdraw
const actionWalletTransactionsSave = (payload) => ({
  type: types.WALLETS_TRANSACTIONS_POST._REQUEST,
  payload,
});

export const actionWalletPortfolioDeposit = (params) =>
  actionWalletTransactionsSave({ ...params, type: 'PortfolioDeposit' });

export const actionWalletPortfolioWithdraw = (params) =>
  actionWalletTransactionsSave({ ...params, type: 'PortfolioWithdraw' });

export const actionWalletDeposit = (params) =>
  actionWalletTransactionsSave({ ...params, type: 'Deposit' });

export const actionWalletWithdraw = (params) =>
  actionWalletTransactionsSave({ ...params, type: 'Withdraw' });

/* Mandates */

export const actionMandatesGet = (payload) => ({ type: types.MANDATES_GET._REQUEST, payload });

export const actionMandatesPost = ({ riskProfileId, name, mandateTypeName }) => ({
  type: types.MANDATES_POST._REQUEST,
  payload: { riskProfileId, name, mandateTypeName },
});

export const actionMandatesPatch = ({ mandateId, published }) => ({
  type: types.MANDATES_PATCH._REQUEST,
  payload: { mandateId, published },
});

export const actionMandateHoldingsGet = (mandateId) => ({
  type: types.MANDATES_HOLDINGS_GET._REQUEST,
  payload: { mandateId },
});

export const actionMandateDetailsGet = (mandateId) => ({
  type: types.MANDATES_DETAILS_GET._REQUEST,
  payload: { mandateId },
});

export const actionMandateHoldingsPost = ({ mandatesId, instrumentId, weight }) => ({
  type: types.MANDATES_HOLDINGS_POST._REQUEST,
  payload: { mandatesId, instrumentId, weight },
});

export const actionMandateHoldingsPatch = ({ mandateId, holdings }) => ({
  type: types.MANDATES_HOLDINGS_PATCH._REQUEST,
  payload: { mandateId, holdings },
});

export const actionMandateKpisGet = (mandateId) => ({
  type: types.MANDATES_KPIS_GET._REQUEST,
  payload: { mandateId },
});

export const actionMandateOptimizationGet = ({ mandateId, targetReturn, forceRetry, url }) => ({
  type: types.MANDATES_OPTIMIZATION_GET._REQUEST,
  payload: { mandateId, targetReturn, forceRetry, url },
});

export const actionMandateImportQuotesPost = ({ mandateId, file }) => ({
  type: types.MANDATES_IMPORT_QUOTES_POST._REQUEST,
  payload: { mandateId, file },
});

export const actionMandatePerformanceGet = ({
  mandateId,
  benchmarkId,
  yearsTag,
  compareIds,
  startDate,
}) => ({
  type: types.MANDATES_PERFORMANCE_GET._REQUEST,
  payload: { mandateId, benchmarkId, yearsTag, compareIds, startDate },
});

export const actionMandateMaxDrawdownGet = ({
  mandateId,
  startDate,
  endDate,
  benchmarkId,
  samplingInterval,
}) => ({
  type: types.MANDATES_MAX_DRAWDOWN_GET._REQUEST,
  payload: { mandateId, startDate, endDate, benchmarkId, samplingInterval },
});

/* Preprocessing Fund Profiles */

export const actionPreprocessingFundProfilesFundsGet = ({
  peerProfileId,
  interval,
  numberOfClusters,
}) => ({
  type: types.PREPROCESSING_FUND_PROFILES_FUNDS_GET._REQUEST,
  payload: { peerProfileId, interval, numberOfClusters },
});

/* Peer profiles */

export const actionPeerProfilesGet = () => ({ type: types.PEER_PROFILES_GET._REQUEST });
export const actionPeerProfilesInstrumentsGet = ({
  peerProfileId,
  startDate,
  endDate,
  numberOfClusters,
}) => ({
  type: types.PEER_PROFILES_INSTRUMENTS_GET._REQUEST,
  payload: { peerProfileId, startDate, endDate, numberOfClusters },
});

export const actionPeerProfilesSelectedInstrumentsGet = (peerProfileId) => ({
  type: types.PEER_PROFILES_SELECTED_INSTRUMENTS_GET._REQUEST,
  payload: { peerProfileId },
});

/* Peer categories */

export const actionPeerCategoriesGet = () => ({ type: types.PEER_CATEGORIES_GET._REQUEST });

export const actionPeerCategoriesInstrumentsGet = (peerCategoryId) => ({
  type: types.PEER_CATEGORIES_INSTRUMENTS_GET._REQUEST,
  payload: { peerCategoryId },
});

/* Instruments */

export const actionPeerCategoriesRecommendInstrument = ({
  peerCategoryId,
  instrumentIds,
  recommended,
}) => ({
  type: types.INSTRUMENTS_PATCH._REQUEST,
  payload: {
    from: 'PEER_CATEGORIES_RECOMMEND',
    peerCategoryId,
    instrumentIds,
    instrument: { recommended },
  },
});

export const actionClusteringToolRecommendInstrument = ({ instrumentIds, recommended }) => ({
  type: types.INSTRUMENTS_PATCH._REQUEST,
  payload: { from: 'CLUSTERING_TOOL_RECOMMEND', instrumentIds, instrument: { recommended } },
});

/* AUMs */

export const actionAumsGet = ({ startDate, endDate }) => ({
  type: types.AUMS_GET._REQUEST,
  payload: { startDate, endDate },
});

export const actionAccountAumsGet = ({ accountId, startDate, endDate }) => ({
  type: types.ACCOUNT_AUMS_GET._REQUEST,
  payload: { accountId, startDate, endDate },
});

/* Fees */

export const actionFeesGet = ({ financialAdvisorId, clientId }) => ({
  type: types.FEES_GET._REQUEST,
  payload: { financialAdvisorId, clientId },
});

/* Model Portfolios */

export const actionModelPortfoliosGet = (userId, { riskProfileId } = {}) => ({
  type: types.MODEL_PORTFOLIOS_GET._REQUEST,
  payload: { userId, riskProfileId },
});

export const actionModelPortfoliosDelete = ({ userId, modelPortfolioIds }) => ({
  type: types.MODEL_PORTFOLIOS_DELETE._REQUEST,
  payload: { userId, modelPortfolioIds },
});

export const actionModelPortfoliosPost = ({ userId, name, riskProfileId, category, serviceTypeId }) => ({
  type: types.MODEL_PORTFOLIOS_POST._REQUEST,
  payload: { userId, name, riskProfileId, category, serviceTypeId },
});

export const actionModelPortfoliosWithKpisGet = (userId) => ({
  type: types.MODEL_PORTFOLIOS_WITH_KPIS_GET._REQUEST,
  payload: { userId },
});

export const actionModelPortfoliosHoldingsGet = (modelPortfolioId) => ({
  type: types.MODEL_PORTFOLIOS_HOLDINGS_GET._REQUEST,
  payload: { modelPortfolioId },
});

export const actionModelPortfoliosDetailsGet = (modelPortfolioId) => ({
  type: types.MODEL_PORTFOLIOS_DETAILS_GET._REQUEST,
  payload: { modelPortfolioId },
});

export const actionModelPortfoliosHoldingsPatch = ({ modelPortfolioId, holdings }, options) => ({
  type: types.MODEL_PORTFOLIOS_HOLDINGS_PATCH._REQUEST,
  payload: { modelPortfolioId, holdings, options },
});

export const actionModelPortfoliosKpisGet = (modelPortfolioId) => ({
  type: types.MODEL_PORTFOLIOS_KPIS_GET._REQUEST,
  payload: { modelPortfolioId },
});

export const actionModelPortfoliosPerformancesGet = ({
  modelPortfolioId,
  benchmarkId,
  yearsTag,
  compareIds,
}) => ({
  type: types.MODEL_PORTFOLIOS_PERFORMANCES_GET._REQUEST,
  payload: { modelPortfolioId, benchmarkId, yearsTag, compareIds },
});

export const actionModelPortfoliosMaxDrawdownGet = (
  { modelPortfolioId, startDate, endDate, benchmarkId, samplingInterval },
  options
) => ({
  type: types.MODEL_PORTFOLIOS_MAX_DRAWDOWN_GET._REQUEST,
  payload: { modelPortfolioId, startDate, endDate, benchmarkId, samplingInterval, options },
});

/* Portfolios */

export const actionPortfoliosSetFilter = (search) => ({
  type: types.PORTFOLIOS_SET_FILTER,
  payload: search,
});

export const actionPortfoliosGet = () => ({
  type: types.PORTFOLIOS_GET._REQUEST,
});

/* Financial Advisor */

export const actionFinancialAdvisorDashboardRequest = () => ({
  type: types.FINANCIAL_ADVISOR_DASHBOARD_GET._REQUEST,
});

export const actionClientDashboardAsAdvisorRequest = (accountId) => ({
  type: types.CLIENT_DASHBOARD_AS_ADVISOR_GET._REQUEST,
  payload: { accountId },
});

export const actionFinancialAdvisorInviteLinkPost = (id) => ({
  type: types.FINANCIAL_ADVISOR_INVITE_LINK_POST._REQUEST,
  payload: { id },
});

/* Leads */

export const actionLeadsGet = (crmId) => ({
  type: types.LEADS_GET._REQUEST,
  payload: { crmId },
});

export const actionLeadsPost = ({ name, email, state, phone, status, crmId }) => ({
  type: types.LEADS_POST._REQUEST,
  payload: { name, email, state, phone, status, crmId },
});

export const actionLeadsPatch = (id, { name, phone, status, crmId }) => ({
  type: types.LEADS_PATCH._REQUEST,
  payload: { id, name, phone, status, crmId },
});

/* Tickets */

export const actionTicketsPost = ({ name, email, subject, message, type, locationUrl }) => ({
  type: types.TICKETS_POST._REQUEST,
  payload: { name, email, subject, message, type, locationUrl },
});

/* Instruments */

export const actionInstrumentsDetailsGet = (instruments) => ({
  type: types.INSTRUMENTS_DETAILS_GET._REQUEST,
  payload: { instruments },
});

export const actionInstrumentsGet = (instrumentId) => ({
  type: types.INSTRUMENTS_GET._REQUEST,
  payload: { instrumentId },
});

export const actionInstrumentsListGet = () => ({
  type: types.INSTRUMENTS_LIST_GET._REQUEST,
});

export const actionInstrumentsPerformanceGet = (payload) => ({
  type: types.INSTRUMENTS_PERFORMANCE_GET._REQUEST,
  payload,
});

export const actionInstrumentsKpisGet = (payload) => ({
  type: types.INSTRUMENTS_KPIS_GET._REQUEST,
  payload,
});

export const actionLatestInstrumentsGet = (params) => ({
  type: types.INSTRUMENTS_LIST_GET._REQUEST,
  payload: { orderBy: 'descdate', limit: 5, ...params },
});

/* EFTs */

export const actionEtfsListGet = (payload) => ({
  type: types.ETFS_LIST_GET._REQUEST,
  payload,
});

export const actionEtfsBroadAssetClassesGet = () => ({
  type: types.ETFS_BROAD_ASSET_CLASSES_GET._REQUEST,
});

export const actionEtfsBenchmarkIndicesGet = () => ({
  type: types.ETFS_BENCHMARK_INDICES_GET._REQUEST,
});

/* EFTs */

export const actionFundsListGet = (payload) => ({
  type: types.FUNDS_LIST_GET._REQUEST,
  payload,
});

export const actionFundsBroadAssetClassesGet = () => ({
  type: types.FUNDS_BROAD_ASSET_CLASSES_GET._REQUEST,
});

export const actionFundsBenchmarkIndicesGet = () => ({
  type: types.FUNDS_BENCHMARK_INDICES_GET._REQUEST,
});

/* Watchlists */

export const actionUserWatchlistInstrumentsGet = (userId) => ({
  type: types.USER_WATCHLISTS_INSTRUMENTS_GET._REQUEST,
  payload: { userId },
});

export const actionUserWatchlistsGet = (userId) => ({
  type: types.USER_WATCHLISTS_GET._REQUEST,
  payload: { userId },
});

export const actionUserWatchlistsPost = (payload) => ({
  type: types.USER_WATCHLISTS_POST._REQUEST,
  payload,
});

export const actionWatchlistsInstrumentsPost = (payload) => ({
  type: types.WATCHLISTS_INSTRUMENTS_POST._REQUEST,
  payload,
});

export const actionWatchlistsInstrumentsDelete = (payload) => ({
  type: types.WATCHLISTS_INSTRUMENTS_DELETE._REQUEST,
  payload,
});

export const actionWatchlistsInstrumentsGet = (watchlistId) => ({
  type: types.WATCHLISTS_INSTRUMENTS_GET._REQUEST,
  payload: { watchlistId },
});

export const actionWatchlistsManager = (payload) => ({
  type: types.WATCHLISTS_MANAGER._REQUEST,
  payload,
});

/* Meetings */
export const actionUserMeetingsGet = (userId, start, end, email) => ({
  type: types.USER_MEETINGS_GET._REQUEST,
  payload: { userId, start, end, email },
});

export const actionUserMeetingTypesGet = (userId) => ({
  type: types.USER_MEETING_TYPES_GET._REQUEST,
  payload: { userId },
});

/* Account Documents */
export const actionAccountDocumentsGet = (accountId) => ({
  type: types.ACCOUNT_DOCUMENTS_GET._REQUEST,
  payload: { accountId },
});

export const actionAccountDocumentsPost = (payload, showSpinner) => ({
  type: types.ACCOUNT_DOCUMENTS_POST._REQUEST,
  payload,
  showSpinner,
});

/* Clients */
export * from './clients';
